import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["container", "template"];

    connect() {
        console.log("SubformController connecté !");
    }

    addSubform(event) {
        event.preventDefault();

        // Clone le template et met à jour les index des champs
        const newSubform = this.templateTarget.content.cloneNode(true);
        const index = this.containerTarget.childElementCount;

        newSubform.querySelectorAll("[name]").forEach((field) => {
            field.name = field.name.replace("INDEX", index);
        });

        this.containerTarget.appendChild(newSubform);
    }

    removeSubform(event) {
        event.preventDefault();
        event.target.closest(".subform-entry").remove();
    }
}
